import React from 'react';
import {
  Form,
  Field,
  Formik,
} from 'formik';
import {
  withApi,
  withNotification,
} from 'wrappers';
import {
  TextBase,
  ButtonSave,
  TextAreaBase,
  ButtonCancel,
} from 'components';
import {
  messages,
} from 'constantes';
import {
  Grid,
  makeStyles,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import endPoints from 'endPoints/endPoints';

const validationSchema = Yup.object({
  correo: Yup.string()
    .email('El campo es inválido')
    .required('El campo es requerido'),
  descripcion: Yup.string().required('El campo es requerido'),
});

const useStyles = makeStyles({
  email: {
    '& .MuiInputBase-input': {
      textTransform: 'none',
    },
  },
});

const SugerenciaForm = ({
  doPost,
  onClose,
  appSuccess,
  genericException,
}) => {
  const classes = useStyles();

  const endPoint = endPoints.centroAyuda.procesos.sugerencias;

  const state = {
    titulo: '',
    correo: '',
    modulo: '',
    descripcion: '',
    tipoSugerencia: '',
  };

  const mapValues = (values) => {
    const {
      correo,
      modulo,
      titulo,
      descripcion,
      tipoSugerencia,
    } = values;

    return {
      correo,
      modulo: modulo.toUpperCase(),
      titulo: titulo.toUpperCase(),
      descripcion: descripcion.toUpperCase(),
      tipo_sugerencia: tipoSugerencia.toUpperCase(),
    };
  };


  const onSubmit = async (formValues) => {
    const url = endPoint.base;
    const data = mapValues(formValues);
    try {
      await doPost({ url, data });
      appSuccess(messages.crud.new);
      onClose();
    } catch (e) {
      genericException(e);
    }
  };

  return (
    <>
      <DialogTitle>
        CREAR SUGERENCIAS
      </DialogTitle>
      <Formik
        enableReinitialize
        initialValues={state}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {() => (
          <Form>
            <DialogContent>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} md={12} xl={12}>
                  <Field
                    label="Correo"
                    name="correo"
                    component={TextBase}
                    className={classes.email}
                  />
                </Grid>
                <Grid item xs={12} md={12} xl={12}>
                  <Field
                    label="Tipo de sugerencia"
                    name="tipoSugerencia"
                    component={TextBase}
                  />
                </Grid>
                <Grid item xs={12} md={12} xl={12}>
                  <Field
                    label="Módulo"
                    name="modulo"
                    component={TextBase}
                  />
                </Grid>
                <Grid item xs={12} md={12} xl={12}>
                  <Field
                    label="Título"
                    name="titulo"
                    component={TextBase}
                  />
                </Grid>
                <Grid item xs={12} md={12} xl={12}>
                  <Field
                    label="Descripción"
                    name="descripcion"
                    component={TextAreaBase}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <ButtonCancel onClick={onClose} />
              <ButtonSave label="Guardar" />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </>
  );
};

SugerenciaForm.propTypes = {
  doPost: PropTypes.func,
  onClose: PropTypes.func,
  appSuccess: PropTypes.func,
  genericException: PropTypes.func,
};

export default withApi(withNotification(SugerenciaForm));
